/**
 * Created by jiachenpan on 16/11/18.
 */
import store from '@/store'
import vueThat from '@/main' // 引入vue
import moment from 'moment'
import { hasPermission } from '@/directive/permission/hasPermi'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xdc00 && code <= 0xdfff) i--
  }
  return s
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @description: 获取指定天数前的00:00:00 & 23:59:59
 * @param {String} type start:开始时间 00:00:00 end:结束时间 23:59:59
 * @param {Numebr} day 天数
 * @return {Dtae} 返回指定时间格式
 */
export function getDateTime(type, day) {
  const datee = new Date()
  // console.log('当前时区下时间', new Date(datee.getTime() - delta * 60 * 60 * 1000), '==========')
  let time = new Date(
    moment(datee)
      .utcOffset(store.getters.usertime.time)
      .format('YYYY-MM-DD HH:mm:ss')
  )

  // console.info(time, '===111==')
  if (type === 'start') {
    let start = day ? time.getTime() - 3600 * 1000 * 24 * day : time
    return new Date(new Date(start).toDateString())
  } else {
    let end = day ? time.getTime() - 3600 * 1000 * 24 * day : time
    return new Date(new Date(new Date(end).toDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * @description: 利用正则匹配将机器人话术转化为有样式可供预览的
 * @param {Array} paramsList 系统提供话术列表，key值格式为大括号包括：{...}
 * @param {String} str 需要转化的话术
 * @return {String} 返回包含html标签的字符串
 */
export function getWordsPreview(paramsList, str) {
  paramsList.forEach(item => {
    let param = item.replace(/\{|}/g, '') // 去除参数的大括号
    var reg = new RegExp('\\{(' + param + '+?)\\}', 'g') // 匹配参数正则
    str = str.replace(reg, `<span class='robotWordsPreview'>${item}</span>`) // 替换话术中所有相同参数，并添加样式
  })
  return str
}

export function hideNumber(phone) {
  // 不隐藏号码
  return phone

  if (!phone) return null
  let phonenumber = phone
  if (!hasPermission(['*view_number*viewNumber*'])) {
    phonenumber = phone.replace(phone.substring(phone.length - 6), '******')
  }
  return phonenumber
}

export function fetchBusinessType(business) {
  store.dispatch('setBusinessType', business)
  // 单个业务场景下对应的意向标签信息
  let businessTags = {}
  switch (business) {
    case 'normal':
      businessTags.lang = 'collectionTags'
      //businessTags.intention = store.getters.intentionTags.collection || []
      //  intention标签
      // businessTags.intention = ['Y', 'U', 'V', 'F', 'N', 'K', 'O', 'L', 'I', 'C', 'D', 'M', 'P', 'B', 'J']
      businessTags.intention = ['Y', 'U', 'V', 'F', 'K', 'O', 'L', 'I', 'C', 'D', 'M', 'P', 'B', 'J']
      // console.log("businessTags.intention=", businessTags.intention)
      businessTags.product = 'collection'
      businessTags.fileType = 1
      businessTags.productName = 'account.collection'
      break
    case 'promotion':
      businessTags.lang = 'marketingTags'
      businessTags.intention = store.getters.intentionTags.marketing || []
      businessTags.product = 'marketing'
      businessTags.fileType = 2
      businessTags.productName = 'account.marketing'
      break
    case 'ic':
      businessTags.lang = 'infoCheckTags'
      businessTags.intention = store.getters.intentionTags.info_check || []
      businessTags.product = 'info_check'
      businessTags.fileType = 4
      businessTags.productName = 'account.info_check'
      break
    case 'cod':
      businessTags.lang = 'codTags'
      businessTags.intention = store.getters.intentionTags.cod || []
      businessTags.product = 'cod'
      businessTags.fileType = 5
      businessTags.productName = 'account.cod'
      break
    case 'Inbound':
      businessTags.lang = 'InboundTags'
      businessTags.intention = store.getters.intentionTags.Inbound || []
      businessTags.product = 'Inbound'
      businessTags.fileType = 6
      businessTags.productName = 'account.Inbound'
      break
  }
  store.dispatch('setBusinessTags', businessTags)
}
export function getLanguage(pre) {
  let language = ''
  switch (vueThat.$i18n.locale) {
    case 'zh':
      language = pre + '_cn'
      break
    case 'en':
      language = pre + '_en'
      break
    case 'ba':
      language = pre + '_id'
      break
  }
  return language
}
export function getParams(name) {
  let keepaliveParams = JSON.parse(sessionStorage.getItem('keepaliveParams'))
  return keepaliveParams ? keepaliveParams[name] : keepaliveParams
}
export function getSubRouteNameByBusiness(subName) {
  let businessType = sessionStorage.getItem('activeName')
  let routeName = 'OPER' + subName
  switch (businessType) {
    case 'ai':
      routeName = 'ai' + subName
      break
    case 'collection':
      routeName = 'collection' + subName
      break
    case 'marketing':
      routeName = 'marketing' + subName
      break
    case 'info_check':
      routeName = 'info_check' + subName
      break
    case 'cod':
      routeName = 'cod' + subName
      break
    default:
      routeName = 'collection' + subName
      break
  }
  // console.log("routeName=", routeName)
  return routeName
}



// WEBPACK FOOTER //
// ./src/utils/index.js